import { ContrastGraphQLFieldConfig } from '..'
import {
  GenericMutationResponse,
  GenericMutationResponseType
} from '../types/generic-mutation-response'
import { Context } from '../shared'
import {
  GraphQLNonNull,
  GraphQLInputObjectType,
  GraphQLString,
  GraphQLID
} from 'graphql'

export const suppressAttackEvent: ContrastGraphQLFieldConfig<
  any,
  Context,
  {
    readonly input: {
      readonly organizationID: string
      readonly eventUuid: string
    }
  },
  GenericMutationResponse
> = {
  description: 'Suppress attack event',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: {
    input: {
      type: new GraphQLInputObjectType({
        name: 'SuppressAttackEventArgs',
        description: 'Parameters for suppressing an attack event.',
        fields: () => ({
          organizationID: {
            description:
              'The ID of the organization that the attack event belongs to',
            type: new GraphQLNonNull(GraphQLID)
          },
          eventUuid: {
            description: 'Attack event UUID',
            type: new GraphQLNonNull(GraphQLString)
          }
        })
      })
    }
  },
  resolve: async (_, args, context) => {
    const {
      input: { organizationID, eventUuid }
    } = args
    const { connector } = context
    await connector.put(
      `/${organizationID}/rasp/events/${eventUuid}/suppress`,
      {
        suppress_similar: false
      }
    )
    return { _placeholder: true }
  }
}
